import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LegacyLoginRoutingModule } from './legacy-login-routing.module';
import { LegacyLoginComponent } from './legacy-login.component';

// `HttpClientModule` n'est volontairement importé que dans `AppModule` (cf. AppUploadFilesModule).
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    LegacyLoginRoutingModule,
    FormsModule
  ],
  declarations: [LegacyLoginComponent],
  exports: [LegacyLoginComponent],
})
export class LegacyLoginModule { }



// WEBPACK FOOTER //
// ./src/app/components/legacy-login/legacy-login.module.ts